/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IMedicationHistory {
  id?: string;
  medicationFor?: string | null;
  medicationStartDate?: string | null;
  medicationEndDate?: string | null;
  medicationDetails?: string | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<IMedicationHistory> = {
  active: false,
  draft: false,
};
